import { useMutation, useQueryClient } from "@tanstack/react-query";
import { updateSportNew } from "@/api/sportsNew";
import { SportsNewQueryKeys } from "@/tanstackQuery/queries/sportsNew/sportsNewQueryKeys";
import { UpdateSportNewParams } from "@/types/ApiResponses/Sport";

export const useUpdateSportNew = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (params: UpdateSportNewParams) => updateSportNew(params),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [SportsNewQueryKeys.SportsNew],
      });
    },
  });
};
